// extracted by mini-css-extract-plugin
export default {"modal-content":"AboutUs_modal-content__mVRAD","container":"AboutUs_container__67kvh","content":"AboutUs_content__wa3VT","header":"AboutUs_header__uH0dC","body":"AboutUs_body__fJW8E"};